import actionTypes from './actionTypes'
import { AnyAction } from 'redux'

const answerSelected = (selectedAnswersIDs: string[], time: number, playerUid: string): IActionAnswerSelected => {
	return {
		type: actionTypes.QUESTION_ANSWER_SELECT,
		selectedAnswersIDs,
		time,
		playerUid,
	}
}

const transitionEnded = (playerUid: string): IActionTransitionEnded => {
	return {
		type: actionTypes.QUESTION_TRANSITION_ENDED,
		playerUid,
	}
}

const getCurrentNumberOfCorrectAnswersByParticipants = () => {
	return {
		type: actionTypes.GET_CURRENT_NUMBER_OF_CORRECT_ANSWERS_BY_PARTICIPANTS,
		params: {},
	}
}

const setCurrentNumberOfCorrectAnswersByParticipants = (payload: any) => {
	return {
		type: actionTypes.SET_CURRENT_NUMBER_OF_CORRECT_ANSWERS_BY_PARTICIPANTS,
		payload,
	}
}

export interface IActionAnswerSelected extends AnyAction {
	selectedAnswersIDs: string[]
	time: number
	playerUid: string
}

export interface IActionTransitionEnded extends AnyAction {
	playerUid: string
}

export default {
	answerSelected,
	transitionEnded,
	getCurrentNumberOfCorrectAnswersByParticipants,
	setCurrentNumberOfCorrectAnswersByParticipants,
}
